export default {
  expandedRegions: 3,
  defaultSorting: 'price',
};
